module.exports = __webpack_public_path__ + "static/coding-e01f500036f02d91d826f1d87ba49aca.png";